import { Pipe, PipeTransform } from '@angular/core';

import { EnterpriseProductivityFeatureFlagService } from '@services/feature-flags/enterprise-productivity';

import { phoneNumberToIntlFormat } from '@lib/utils';

@Pipe({
  name: 'phoneIntlFormat',
})
export class PhoneIntlFormatPipe implements PipeTransform {
  constructor(private enterpriseFFService: EnterpriseProductivityFeatureFlagService) {}
  transform(value: string, countryCode?: string): string {
    if (!value) return '';

    if (this.enterpriseFFService.isGlobalCountryCodesEnabled()) {
      return phoneNumberToIntlFormat(value, countryCode);
    }

    return value;
  }
}